
<template>
    <div class="OperateNavTable">
        <div v-for="(pack,unit) in [['第一名','第二名','第三名','第四名','第五名'],['第六名','第七名','第八名','第九名','第十名']]" class="l-flex o-mb">
            <template v-for="(item,index) in pack">
                <div v-if="index" style="padding:0 .2rem;" />
                <div class="l-flex-1">
                    <div v-if="item" class="row-title c-text-c">{{ item }}</div>
                    <group v-if="item" :client="client" :list="Table[unit * 5 + index + 1]" :length="1" />
                </div>
            </template>
        </div>
        <BoardFast :client="client" :group="TableAll" :step="true" :default-step="0.1" />
    </div>
</template>

<script>
import CommonMix from '../common.js'
import Group from '../group.vue'
export default {
    name: 'OperatePks3',
    mixins: [CommonMix],
    props: {
        client: {}
    },
    components: {
        Group
    }
}
</script>
